export const dateFnsFormats = {
    'dd.MM.y': 'dd.MM.yyyy',
    'MM.y': 'MM.yyyy',
    'y': 'yyyy',
};
